import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pl from './locales/pl.json';

const LANGUAGE_KEY = 'admin-language';

const resources = {
  en: { translation: en },
  pl: { translation: pl },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem(LANGUAGE_KEY) || (navigator.language?.startsWith('pl') ? 'pl' : 'en'),
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
export { LANGUAGE_KEY };
